
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/update/[...UpdateId]",
      function () {
        return require("private-next-pages/update/[...UpdateId].js");
      }
    ]);
  